import axios from 'axios';
import React from 'react';

// Create an axios instance with default configurations
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'https://erp-api-stage.graydev.tech/v1',
    headers: {
      'GQ-API-Key': process.env.REACT_APP_GQ_API_KEY,
      'Authorization': process.env.REACT_APP_AUTHORIZATION,
      'Content-Type': 'application/json'
    }
  });

/**
 * Fetches EMI plans for a given loan amount
 * @param {number} loanAmount - The loan amount to get EMI plans for
 * @returns {Promise} Promise resolving to EMI plans data
 */
export const fetchEMIPlans = async (loanAmount) => {
  try {
    const response = await apiClient.get('/product/emi-plans', {
      params: {
        loan_amount: loanAmount,
        type: 'recommended'
      }
    });

    return response.data;
  } catch (error) {
    // Error handling
    console.error('Error fetching EMI plans:', error);
    
    // You can customize error handling
    if (error.response) {
      // The request was made and the server responded with a status code
      throw new Error(error.response.data.message || 'Failed to fetch EMI plans');
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error('No response received from server');
    } else {
      // Something happened in setting up the request
      throw new Error('Error setting up EMI plans request');
    }
  }
};

// Example hook for using the API in a React component
export const useEMIPlans = () => {
    const [emiPlans, setEMIPlans] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [totalEMIAmount, setTotalEMIAmount] = React.useState(null);
  
    const getEMIPlans = React.useCallback(async (loanAmount) => {
      setLoading(true);
      setError(null);
      try {
        const plans = await fetchEMIPlans(loanAmount);
        setEMIPlans(plans);
  
        // Extract plan_total_emi_amount from the first row
        if (
          plans && 
          plans.data && 
          Array.isArray(plans.data) && 
          plans.data.length > 0
        ) {
          setTotalEMIAmount(plans.data[0].plan_total_emi_amount);
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    }, []);
  
    return { 
      emiPlans, 
      loading, 
      error, 
      getEMIPlans,
      totalEMIAmount 
    };
  };